export const STATSIG_EXPERIMENTS = {
    CSM_AI_AGENT_ON_SAC: 'csm-ai-agent-on-sac'
};

export const STATSIG_EXPERIMENTS_DEFAULTS = {
    'csm-ai-agent-on-sac': {
        agent_enabled: false
    }
};
